import { ROLE_ADMIN, ROLE_PARTNER_ADMIN, ROLE_SUPERADMIN } from '../../constants/roles';
import { createHasSessionAccessSelector } from '../session';

export const selectCanAccessDashboardManagement = createHasSessionAccessSelector([ROLE_SUPERADMIN]);
